import { Alert, Slide, Snackbar } from "@mui/material";
import React from "react";

export const ErrorSnackbar = ({ error, handleCloseError, errorMsg }) => {
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    handleCloseError();
  };

  return (
    <Snackbar
      open={error}
      autoHideDuration={5000}
      onClose={handleSnackbarClose}
      TransitionComponent={(props) => <Slide {...props} direction="up" />}
    >
      <Alert
        onClose={handleCloseError}
        severity="error"
        variant="filled"
        sx={{ width: "100%" }}
      >
        {errorMsg}
      </Alert>
    </Snackbar>
  );
};

export const ConfirmationSnackbar = ({
  snackbarState,
  handleSnackbarClose,
  action,
  text,
}) => {
  return (
    <Snackbar
      open={snackbarState}
      autoHideDuration={4000}
      onClose={handleSnackbarClose}
    >
      <Alert
        onClose={handleSnackbarClose}
        severity="success"
        variant="filled"
        sx={{ width: "100%" }}
        action={action}
      >
        {text}
      </Alert>
    </Snackbar>
  );
};
